export const SEASON_TABLE_NAME = 'falling_block_puzzle_season1' as const;
